module.exports = __webpack_public_path__ + "static/img/empty_4.5dd89328.png";